<template>
  <div id="info-overlay">
    <b-row class="p-5" id="info-row">
      <b-col>
        <b-row class="text-center">
          <b-col>
            <h1>Szanowny Użytkowniku, bieżąca organizacja posiada nieaktualne lub błędne informacje w profilu podmiotu
              na PUE UKE.</h1>
          </b-col>
        </b-row>
        <hr/>
        <b-row class="text-center pt-1 pb-5">
          <b-col>
            <p>
              W celu ich uzupełnienia lub poprawy, przejdź do systemu <a class="link-underlined" href="https://pue.uke.gov.pl/" target="_blank">PUE UKE</a> i wprowadź stosowne zmiany (np.: nr RPT, nr RJST, rodzaju formy prawnej) w wybranym podmiocie użytkownika. W przypadku problemów prosimy o przesłanie zgłoszenia na <a class="link-underlined" href="mailto:pue@uke.gov.pl">pue@uke.gov.pl</a>.
            </p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'permission-denied-overlay'
}
</script>

<style scoped>
</style>
